import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

/**
 *
 * @returns {Promise<object[]>}
 */
export const selectEmpleados = async () => {
    try {
        const resp = await axios.get(`${API_URL}/empleados/select`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectEmpleadosConReglasOSecuencias = async () => {
    try {
        const resp = await axios.get(`${API_URL}/empleados/select/conReglas`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

/**
 * Obtiene los empleados que no tienen asignada una regla o secuencia,
 * a excepcion de aquellos que están asignados a la regla o secuencia con el id {id}
 * @param {number} id de la regla o de la secuencia
 * @param {string} tipo tabla con la que se comparará el {id} a la hora de buscar los empleados
 * @returns
 */
export const selectEmpleadosSinReglasOSecuencias = async (id = null, tipo = 'reglas') => {
    try {
        const resp = await axios.get(
            `${API_URL}/empleados/select/sinReglas` + (`/${id}` ?? "") + `?tipo=${tipo}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectEmpleadosPorRegla = async (idRegla) => {
    try {
        const resp = await axios.get(
            `${API_URL}/empleados/select/porRegla/${idRegla}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
